module.exports = __webpack_public_path__ + "media/categories/1002-a63799fc.svg";